import { Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import { routePath } from '~/utils/constants';
import { useCommon } from '~/utils/hook/useCommon';
import { BaseDialog } from './BaseDialog';

export const AdminReloginDialog = () => {
  const open = useSelector(
    (state: RootState) => state.user.showAdminReloginDialog,
  );
  const { deleteToken } = useCommon();

  const goRelogin = () => {
    deleteToken();
    const { pathname, search } = window.location;
    const redirect = encodeURIComponent(`${pathname}${search}`);
    window.location.replace(`${routePath.adminLogin}?redirect=${redirect}`);
  };

  if (!open) return null;

  return (
    <BaseDialog
      open={open}
      handleClose={goRelogin}
      title="登入已逾期"
      action={
        <Button variant="contained" onClick={goRelogin}>
          重新登入
        </Button>
      }
    >
      <Typography variant="body1">
        您的登入狀態已失效，請重新登入後再繼續操作。
      </Typography>
    </BaseDialog>
  );
};
